import parseISO from 'date-fns/parseISO';

import { getSessionBlock } from '@shared/helpers';
import type { AvailablePeriod } from '@shared/types/available-periods';

export const isAvailableNow = (available?: AvailablePeriod) => {
	if (!available) return false;
	const { start_time, end_time } = available;
	const start = parseISO(start_time);
	const end = parseISO(end_time);

	const current = new Date();
	return start <= current && current <= end;
};

export const isAvailableActive = (mode: string, available?: AvailablePeriod) => {
	if (!available) return false;
	return available.status.findIndex((availableMode) => availableMode === mode) !== -1;
};

export const availableHasId = (
	session: { start: Date; end: Date },
	tz: string,
	start?: string,
	end?: string
) => {
	if (!start || !end) return '';
	return ['start', 'start_bottomOverlap', 'end_topOverlap', 'single'].includes(
		getSessionBlock(session, tz, start, end)
	)
		? start
		: '';
};
